import { useCallback } from "react";
import { MapType } from "../../types/map/types";

interface UseMapTypeProps {
  map?: google.maps.Map;
}

export const useMapType = ({ map }: UseMapTypeProps = {}) => {
  const setMapType = useCallback(
    (type: MapType) => {
      if (!map) return;
      map.setMapTypeId(type as google.maps.MapTypeId);
    },
    [map]
  );

  return {
    setMapType,
  };
};
